var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 16C8.45914 16 10.25 14.2091 10.25 12H15.4669V15H17.4669V12H20.25V16H22.25V11V10H21.25H16.4669H9.71487C9.02325 8.8044 7.73056 8 6.25 8C4.04086 8 2.25 9.79086 2.25 12C2.25 14.2091 4.04086 16 6.25 16ZM8.25 12C8.25 10.8954 7.35457 10 6.25 10C5.14543 10 4.25 10.8954 4.25 12C4.25 13.1046 5.14543 14 6.25 14C7.35457 14 8.25 13.1046 8.25 12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyHorizontal);
export default __webpack_public_path__ + "static/media/key_horizontal.c38ea5067608accfb9a82e68729947c5.svg";
export { ForwardRef as ReactComponent };